import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useAppStore } from "@/store";
import { ScheduleWizard } from "@/components/form-schedules/wizard/schedule-wizard";
import { PageHeader, Breadcrumbs } from "@/components/ui";

export const Route = createFileRoute("/_authenticated/test-program/schedules/new")({
  component: FormScheduleNewPage,
});

/**
 * Creation surface for RRULE-driven premise-inspection schedules: the 4-step
 * wizard (Basics → Recurrence → Facilities → Review). The wizard owns the
 * create mutation, the 422 coherence step-jumping, and the abandon guard.
 */
function FormScheduleNewPage() {
  const { t } = useTranslation(["test-cadence", "nav"]);
  const orgId = useAppStore((s) => s.activeOrgId);

  return (
    <div className="mx-auto max-w-4xl p-8">
      <Breadcrumbs
        items={[
          {
            label: t("testProgram.schedules", { ns: "nav" }),
            to: "/test-program",
            search: { tab: "schedules" },
          },
          { label: t("schedules.wizard.title") },
        ]}
      />
      <PageHeader title={t("schedules.wizard.title")} />

      <div className="mt-6">{orgId && <ScheduleWizard orgId={orgId} />}</div>
    </div>
  );
}
